// hooks
import useAuth from '../hooks/useAuth';
// utils
import createAvatar from '../utils/createAvatar';
//
import Avatar, { Props as AvatarProps } from './Avatar';

// ----------------------------------------------------------------------

export default function MyAvatar({ ...other }: AvatarProps) {
  const { user } = useAuth();

  return (
    <Avatar
      alt={user?.displayName}
      color={createAvatar(user?.displayName || '').color}
      {...other}
    >
      {createAvatar(user?.displayName || '').name}
    </Avatar>
  );
}
